import { render, staticRenderFns } from "./NewApplicationQuestionTemplateAction.vue?vue&type=template&id=5db955d0&"
import script from "./NewApplicationQuestionTemplateAction.vue?vue&type=script&lang=js&"
export * from "./NewApplicationQuestionTemplateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
